import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Icon, Collapse, message } from 'antd';
import { Checkbox, Tooltip } from 'antd';
import { getSingleWager, takeWager as takeWagerApi } from '../../api-calls/wagers';
import { takeWager as takeContractWager } from '../../contract/WagersController';
import { getSingleEvent } from '../../api-calls/events';
import OddsBars from '../oddsComponents/OddsBars';
import { getSingleTeam } from "../../api-calls/teams";
import CreatorName from '../layoutComponents/CreatorName';
import { FaUserSecret, FaEnvelopeOpenText } from 'react-icons/fa';
const ethMultiplier = 1000000000000000000;


Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore", "CustomRouter", "TeamStore"])
class TakeBetModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logoOne: <Icon style={{ marginLeft: "22%", fontSize: '46px', color: '#08c' }} type="loading" />,
            logoTwo: <Icon style={{ marginLeft: "52%", fontSize: '46px', color: '#08c' }} type="loading" />,
            betMaker: <Icon style={{ fontSize: '16px', color: '#08c' }} type="loading" />,
            teamOne: "",
            teamOneColor: '#5b616b',
            teamTwo: "",
            teamTwoColor: '#3296f7',
            teamOneGraphData: 0.5,
            teamTwoGraphData: 0.5,
            isPropBet: false,
            propTitle: "",
            propEventTeamOne: "",
            propEventTeamTwo: "",
            wager: { makerChoice: 0 },
            loadingWager: true,
            teamOneName: "",
            teamTwoName: "",
            betChoice: "",
            eventNotOver: false,
            amountToTake: 0,
            amountToWin: 0,
            event: { teams: [] },
            takeBetButton: <Icon type="loading" />

        };
        this.takeBet = this.takeBet.bind(this);

    }

    componentWillMount() {
        const { TeamStore } = this.props;
        let self = this;
        TeamStore.queryTeams();
    }

    async componentDidMount() {
        const { CustomRouter } = this.props;
        this.props.ViewStore.changeView('Take Bet');
        this.props.ViewStore.changeCurrentPage('Take Bet');
        let self = this;

        getSingleWager(CustomRouter.router.params.betId).then((wager) => {
            let thisBetChoice;


            console.log("wager " + JSON.stringify(wager[0]));
            let currentTakeBetButton;
            if (!wager[0].cancelled && wager[0].taker == undefined) {
                currentTakeBetButton = <button onClick={this.takeBet}>Take Bet</button>;

            } else {
                currentTakeBetButton = <div style={{ color: "#f72727" }} className="single-event-page-card-wagers-title">Sorry, bet is no longer available</div>
            }

            let amountToTake;
            if (wager[0].odds > 99) {
                amountToTake = (wager[0].value) / (wager[0].odds / 100);
            } else {
                amountToTake = (wager[0].value) * Math.floor(100 / wager[0].odds);

            }



            self.setState({
                wager: wager[0],
                betMaker: wager[0].maker,
                takeBetButton: currentTakeBetButton,

                amountToTake: amountToTake / ethMultiplier,
                amountToWin: wager[0].value / ethMultiplier
            });
            getSingleEvent(wager[0].eventId).then((event) => {
                console.log("event found " + JSON.stringify(event));
                let d = new Date();
                console.log("date is " + d.getTime() / 1000);
                let overBool = event.startTime + event.duration > d.getTime() / 1000;
                console.log("overbool " + overBool);

                if (event.teams.length == 2 && !event.drawPossible) {
                    thisBetChoice = (wager[0].makerChoice == 1 ? 2 : 1);
                } else {
                    thisBetChoice = -wager[0].makerChoice;
                }


                if (event.isPropEvent) {



                    self.setState({
                        isPropBet: true,
                        propEventTeamOne: event.teams[0],
                        propEventTeamTwo: event.teams[1],
                        propTitle: event.propTitle,
                        loadingWager: false,
                        eventNotOver: overBool,




                    });

                    getSingleEvent(event.originalEventId).then((originalEvent) => {
                        let betsForTeamOne = originalEvent.betsForTeamOne;
                        let betsForTeamTwo = originalEvent.betsForTeamTwo;
                        let amountBetForOne = originalEvent.amountBetForOne;
                        let amountBetForTwo = originalEvent.amountBetForTwo;
                        let teamOneGraphData;
                        let teamTwoGraphData;

                        if (betsForTeamOne == 0 && betsForTeamTwo == 0) {

                            teamOneGraphData = 50 / 100;

                            teamTwoGraphData = 50 / 100;
                        } else if (betsForTeamOne > 0 && betsForTeamTwo == 0) {

                            teamOneGraphData = 1;
                            teamTwoGraphData = 0;
                        } else if (betsForTeamOne == 0 && betsForTeamTwo > 0) {

                            teamTwoGraphData = 1;
                            teamOneGraphData = 0;

                        } else {

                            teamOneGraphData = amountBetForOne / (amountBetForOne + amountBetForTwo);
                            teamTwoGraphData = amountBetForTwo / (amountBetForOne + amountBetForTwo);

                        }
                        self.setState({
                            teamOne: originalEvent.teams[0],
                            teamOneColor: originalEvent.teamOneColor,
                            teamTwo: originalEvent.teams[1],
                            teamTwoColor: originalEvent.teamTwoColor,
                            teamOneGraphData,
                            teamTwoGraphData
                        });

                        getSingleTeam(self.state.teamOne).then((teamOne) => {
                            self.setState({
                                logoOne: <img src={teamOne.logoUrl} />,
                                teamOneName: teamOne.name
                            });

                        });
                        getSingleTeam(self.state.teamTwo).then((teamTwo) => {
                            self.setState({
                                logoTwo: <img src={teamTwo.logoUrl} />,
                                teamTwoName: teamTwo.name
                            });
                        });
                    });

                } else {
                    let betsForTeamOne = event.betsForTeamOne;
                    let betsForTeamTwo = event.betsForTeamTwo;
                    let amountBetForOne = event.amountBetForOne;
                    let amountBetForTwo = event.amountBetForTwo;
                    let teamOneGraphData;
                    let teamTwoGraphData;

                    if (betsForTeamOne == 0 && betsForTeamTwo == 0) {

                        teamOneGraphData = 50 / 100;

                        teamTwoGraphData = 50 / 100;
                    } else if (betsForTeamOne > 0 && betsForTeamTwo == 0) {

                        teamOneGraphData = 1;
                        teamTwoGraphData = 0;
                    } else if (betsForTeamOne == 0 && betsForTeamTwo > 0) {

                        teamTwoGraphData = 1;
                        teamOneGraphData = 0;

                    } else {

                        teamOneGraphData = amountBetForOne / (amountBetForOne + amountBetForTwo);
                        teamTwoGraphData = amountBetForTwo / (amountBetForOne + amountBetForTwo);

                    }
                    self.setState({
                        teamOne: event.teams[0],
                        teamOneColor: event.teamOneColor,
                        teamTwo: event.teams[1],
                        teamTwoColor: event.teamTwoColor,
                        teamOneGraphData,
                        teamTwoGraphData,
                        eventNotOver: overBool,
                        loadingWager: false,
                        betChoice: thisBetChoice,
                    });

                    getSingleTeam(self.state.teamOne).then((teamOne) => {
                        self.setState({
                            logoOne: <img width="72px" src={teamOne.logoUrl} />,
                            teamOneName: teamOne.name
                        });

                    });
                    getSingleTeam(self.state.teamTwo).then((teamTwo) => {
                        self.setState({
                            logoTwo: <img width="72px" src={teamTwo.logoUrl} />,
                            teamTwoName: teamTwo.name
                        });
                    });
                }
                self.setState({ event });

            });
        });
    }

    takeBet() {
        const { web3Store, AuthStore, UserStore, WagerStore } = this.props;
        let token = AuthStore.userAuth.auth.accessToken;
        let wager = this.state.wager;
        let amountToTake;
        let self = this;

        if (wager.odds > 99) {
            amountToTake = (wager.value) / (wager.odds / 100);
        } else {
            amountToTake = (wager.value) * Math.floor(100 / wager.odds);

        }

        //console.log("wager to take " + JSON.stringify(wager));
        //console.log("endTime" + start_time+duration);
        if (Date.now() > (wager.startTime + wager.duration) * 1000) {
            message.info("You can't take bets, the event has finished.");
        } else {
            console.log("wager.odds " + wager.odds);
            console.log("wager.value " + wager.value);
            console.log(wager.value / (wager.odds / 100));
            self.setState({ takeBetButton: <Icon style={{ fontSize: '22px', color: '#08c' }} type="loading" /> });

            //  console.log("DIV -- " + Math.floor((wager.value * ethMultiplier) / Math.floor(wager.odds / 100)));
            takeContractWager(wager.bytes32Id, amountToTake).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)

                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! No bet made.");
                        self.setState({ takeBetButton: <button onClick={self.takeBet}>Take Bet</button> });
                    } else {
                        return takeWagerApi(token,
                            UserStore.user._id,
                            wager._id,
                            wager.bytes32Id,
                            amountToTake,
                            web3Store.account,
                            wager.eventId,
                            wager.makerChoice).then(function () {
                                // WagerStore.queryEventWagers(wager.eventId);
                                self.setState({ takeBetButton: <Icon style={{ fontSize: '22px', color: '#3ac55a' }} type="check-circle" /> });
                                return UserStore.updateUser(token);
                            });
                    }
                });
        }

    }



    render() {
        const { CustomRouter, TeamStore } = this.props;
        console.log(JSON.stringify(this.state.wager));
        console.log(JSON.stringify(this.state.event));


        return <div >
            <div style={{ textAlign: "center" }} className="single-event-page-rows-teams">
                <div className="single-event-page-rows-teams-teamone">
                    {this.state.logoOne}
                </div>
                <div className="single-event-page-rows-teams-teamtwo">
                    {this.state.logoTwo}
                </div>
            </div>
            {/* <OddsBars teamOneData={this.state.teamOneGraphData} teamOneColor={this.state.teamOneColor} teamTwoData={this.state.teamTwoGraphData} teamTwoColor={this.state.teamTwoColor} /> */}
            <br />
            <div className="single-event-page-card-wagers-title">{this.state.teamOneName} vs {this.state.teamTwoName}</div>
            <div >
                {this.state.wager.isPrivate ? <Tooltip title={<span>Only those with the link can find this bet.</span>} > <span style={{ color: '#08c', fontSize: '14px' }}>PRIVATE <FaUserSecret /></span></Tooltip> :
                    <Tooltip title={<span>Anyone can take this bet at anytime.</span>} > <span style={{ color: '#08c', fontSize: '14px' }}>PUBLIC <Icon type="notification" /></span></Tooltip>}
            </div>
            <br />
            {this.state.isPropBet ? <div className="single-event-page-card-wagers-title">{this.state.propTitle}<div>{this.state.propEventTeamOne} or {this.state.propEventTeamTwo}</div></div> : null}
            {this.state.isPropBet ? <span className="single-event-page-card-wagers-title">You are betting: <span style={{ color: "#3ac55a" }}>{(this.state.betChoice == 1 ? this.state.propEventTeamOne : this.state.propEventTeamTwo)}</span></span>
                : <span className="single-event-page-card-wagers-title">You are betting {this.state.betChoice > 0 ? <span>for <span style={{ color: "#3ac55a" }}>{

                    (this.state.betChoice == 1 ? this.state.teamOneName : this.state.teamTwoName)
                }</span> to win</span> :
                    <span>against <span style={{ color: "#f72727" }}>{
                        -this.state.betChoice == this.state.event.teams.length + 1 ? "A DRAW" : (
                            TeamStore.teams.get(this.state.event.teams[this.state.wager.makerChoice - 1]) !== undefined ? TeamStore.teams.get(this.state.event.teams[this.state.wager.makerChoice - 1]).name : "loading team")}</span> </span>
                }</span>}
            <div className="single-event-page-card-wagers-title">BET CREATOR: <CreatorName userId={this.state.wager.maker} /></div>
            <div className="single-event-page-card-wagers-title">AMOUNT TO TAKE: <span style={{ color: "#f72727" }}>{this.state.amountToTake.toFixed(4)}</span></div>
            <div className="single-event-page-card-wagers-title">AMOUNT YOU COULD WIN: <span style={{ color: "#3ac55a" }}>{this.state.amountToWin.toFixed(4)}</span></div>
            <br />


            {/* {this.state.takeBetButton} */}

            {this.props.AuthStore.userAuth.auth ? (this.state.loadingWager ? <Icon type="loading" /> :
                this.state.takeBetButton)
                : <div style={{ color: '#08c' }} className="single-event-page-card-wagers-title">You must be logged in to take bet</div>}


            <br />
            <br />
        </div>
    }

}

export default observer(TakeBetModal);


// WEBPACK FOOTER //
// ./src/components/modals/TakeBetModal.js